export default "__VITE_ASSET__BJjZahhK__"